<template><div class="main">
  <sticky-bar>Administration</sticky-bar>
  <div class="content">
    <div class="fill flex">
      <div class="flex-toolbar">
        <router-link to="/a/email">Mass Email</router-link>
        <router-link to="/a/login">Login</router-link>
      </div>
      <div class="flex-fill padded scroll">
        <router-view />
      </div>
    </div>
  </div>
</div></template>
<script>
import StickyBar from './StickyBar'
export default {
  name: 'admin',
  components: { StickyBar },
}
</script>
<style lang="scss" scoped>


</style>
